import { Svg } from 'components/svg'

export const HomeIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M17.482,18.653h-14a1,1,0,0,1-1-1v-8h-2L9.774.36a1,1,0,0,1,1.415,0l9.293,9.293h-2v8A1,1,0,0,1,17.482,18.653Zm-9-7h4v5h4V8.481l-6-6-6,6v8.172h4Z"
      transform="translate(1.518 2.64)"
      fill="currentColor"
    />
  </Svg>
)
